var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6688 7.59851C12.8854 7.37689 12.7284 7.00386 12.4185 7.00386H10.45C10.2567 7.00386 10.1 6.84716 10.1 6.65386V1.35C10.1 1.1567 9.9433 1 9.75 1H6.25C6.0567 1 5.9 1.1567 5.9 1.35V6.65386C5.9 6.84716 5.7433 7.00386 5.55 7.00386H3.58153C3.27163 7.00386 3.11462 7.37689 3.33124 7.59851L7.74971 12.1189C7.88701 12.2594 8.11299 12.2594 8.25029 12.1189L12.6688 7.59851ZM13.775 15C13.9683 15 14.125 14.8433 14.125 14.65V14.0375C14.125 13.8442 13.9683 13.6875 13.775 13.6875H2.225C2.0317 13.6875 1.875 13.8442 1.875 14.0375V14.65C1.875 14.8433 2.0317 15 2.225 15H13.775Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6688 7.59851C12.8854 7.37689 12.7284 7.00386 12.4185 7.00386H10.45C10.2567 7.00386 10.1 6.84716 10.1 6.65386V1.35C10.1 1.1567 9.9433 1 9.75 1H6.25C6.0567 1 5.9 1.1567 5.9 1.35V6.65386C5.9 6.84716 5.7433 7.00386 5.55 7.00386H3.58153C3.27163 7.00386 3.11462 7.37689 3.33124 7.59851L7.74971 12.1189C7.88701 12.2594 8.11299 12.2594 8.25029 12.1189L12.6688 7.59851ZM13.775 15C13.9683 15 14.125 14.8433 14.125 14.65V14.0375C14.125 13.8442 13.9683 13.6875 13.775 13.6875H2.225C2.0317 13.6875 1.875 13.8442 1.875 14.0375V14.65C1.875 14.8433 2.0317 15 2.225 15H13.775Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadFill);
export default __webpack_public_path__ + "static/media/download-fill.7018cf4f.svg";
export { ForwardRef as ReactComponent };